import React, { Fragment, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import RequiredField from "../../../../Constant";
import { Breadcrumbs, H5 } from "../../../../AbstractElements";
import { useNavigate } from "react-router";
import { faL } from "@fortawesome/free-solid-svg-icons";


const MAX_SLOTS = 7;
const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const TimeSlotForm = ({ setSteps }) => {
  const navigate = useNavigate();

  const [formdata, setFormdata] = useState({});
  const [view, setView] = useState(false);
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");
  const [holiDay, setHoliDay] = useState(false);
  const [slots, setSlots] = useState([]);

  const handleDayRangeChange = (start, end) => {
    setStartDay(start);
    setEndDay(end);
    // Initialize slots if range is selected
    if (start) {
    // if (start && end) {
      setSlots([{ id: Date.now(), label: 'Slot 1', value: '' }]);
    }
  };

  const addSlot = () => {
    if (slots.length < MAX_SLOTS) {
      setSlots([...slots, { id: Date.now(), label: `Slot ${slots.length + 1}`, value: '' }]);
    }
  };

  const removeSlot = (id) => {
    if (slots.length > 1) {
      setSlots(slots.filter(slot => slot.id !== id));
    }
  };
// 
  const handleValueChange = (id, value) => {
    setSlots(slots.map(slot => slot.id === id ? { ...slot, value } : slot));
  };
  const handleHoliday = (val, n) => {
    setHoliDay(!holiDay)
    console.log(n)
  };
// 
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  
  const onSubmit = (data,e ) => {
    e.preventDefault()
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    console.log(data)
  };
  // 
  return (
    <Fragment>
      <Breadcrumbs parent="Branch" mainTitle="Slot Form" title="Time Slot" />
      <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
        <Row className={!view ? "justify-content-center" : "justify-content-center"}>
          {!view && (
            <Col sm="8" className="m-0 p-0">
              <Card className="border-0">
                <CardHeader className="text-white bg-dark"><H5>Time Slot</H5></CardHeader>
                <CardBody>
                 
                  <FormGroup className="mb-3">
                    <Label htmlFor="startDay">Start Day</Label>
                    <Input
                      type="select"
                      id="startDay"
                      onChange={(e) => handleDayRangeChange(e.target.value, endDay)}
                      value={startDay}
                      // {...register("startDay", { required: true })}
                    >
                      <option value="">Select Start Day</option>
                      {WEEKDAYS.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label htmlFor="endDay">End Day</Label>
                    <Input
                      type="select"
                      id="endDay"
                      onChange={(e) => handleDayRangeChange(startDay, e.target.value)}
                      value={endDay}
                      {...register("endDay", { required: true })}
                    >
                      <option value="">Select End Day</option>
                      {WEEKDAYS.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label htmlFor="endDay">Branch</Label>
                    <Input
                      type="select"
                      id="branch"
                      // onChange={(e) => handleDayRangeChange(startDay, e.target.value)}
                      // value={endDay}
                      {...register("branch", { required: true })}
                    >
                      <option value="">Select Branch</option>
                      <option value=""> Branch 1</option>
                      <option value=""> Branch 2</option>
                      {/* {WEEKDAYS.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))} */}
                    </Input>
                  </FormGroup>
                  <FormGroup className="mb-3 d-flex align-items-center gap-3">
                      {/* <Label className="d-block d-flex">
              <Input className={`form-control  checkbox_animated ${errors.holiday && "is-invalid"}`} id='holiday' value={holiDay}  type="checkbox" onChange={handleHoliday}  {...register("holiday", { required: false })} />
                   {'Mark it as Holiday'}
              </Label> */}
                        <Label htmlFor="endtime">Mark it as Holiday</Label>
                        <input
                          className={` ${errors.holiday && "is-invalid"}`}
                          // className={`form-control ${errors.holiday && "is-invalid"}`}
                          id="holiday"
                          type="checkbox"
                          name="holiday"
                          value={holiDay}
                          onChange={(e)=>handleHoliday(e.target.value, "fgs")}
                          defaultValue={formdata.holiday || ""}
                          {...register("holiday", { required: false })}
                        />
                        {/* <span className="text-danger">{errors.endtime && "oliday is required"}</span> */}
                      </FormGroup>

                  {/* {startDay  && ( */}
                  {!holiDay && startDay  && (
                    <Fragment>
                      <FormGroup className="mb-3">
                        <Label htmlFor="starttime">Start Time <RequiredField /></Label>
                        <input
                          className={`form-control ${errors.starttime && "is-invalid"}`}
                          id="starttime"
                          type="time"
                          name="starttime"
                          defaultValue={formdata.starttime || ""}
                          {...register("starttime", { required: !holiDay? true:false })}
                        />
                        <span className="text-danger">{errors.starttime && "Start Time is required"}</span>
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <Label htmlFor="endtime">End Time <RequiredField /></Label>
                        <input
                          className={`form-control ${errors.endtime && "is-invalid"}`}
                          id="endtime"
                          type="time"
                          name="endtime"
                          defaultValue={formdata.endtime || ""}
                          {...register("endtime", { required: false })}
                        />
                        <span className="text-danger">{errors.endtime && "End Time is required"}</span>
                      </FormGroup>
                      

                   <div className="d-flex gap-5 align-items-center justify-content-center">
                        <FormGroup className="mb-3">
                          <Label htmlFor="breaktimefrom">Break Time From <RequiredField /></Label>
                          <input
                            className={`form-control ${errors.breaktimefrom && "is-invalid"}`}
                            id="breaktimefrom"
                            type="time"
                            name="breaktimefrom"
                            defaultValue={formdata.breaktimefrom || ""}
                            {...register("breaktimefrom", { required: false })}
                          />
                          <span className="text-danger">{errors.breaktimefrom && "Break Time From is required"}</span>
                        </FormGroup>

                        <FormGroup className="mb-3">
                          <Label htmlFor="breaktimeto">Break Time To <RequiredField /></Label>
                          <input
                            className={`form-control ${errors.breaktimeto && "is-invalid"}`}
                            id="breaktimeto"
                            type="time"
                            name="breaktimeto"
                            defaultValue={formdata.breaktimeto || ""}
                            {...register("breaktimeto", { required: false })}
                          />
                          <span className="text-danger">{errors.breaktimeto && "Break Time To is required"}</span>
                        </FormGroup>
                      </div>

                      {slots.map((slot) => (
                        <FormGroup key={slot.id} className="mb-3">
                          <Label htmlFor={`slot-${slot.id}`}>{slot.label}</Label>
                          <Controller
                            name={`slot-${slot.id}`}
                            control={control}
                            defaultValue={slot.value}
                            render={({ field }) => (
                              <input
                                className={`form-control ${errors[`slot-${slot.id}`] && "is-invalid"}`}
                                id={`slot-${slot.id}`}
                                type="number"
                                min="0"
                                max="60"
                                placeholder="5 Mins"
                                {...field}
                                value={slot.value}
                                onChange={(e) => {
                                  field.onChange(e);
                                  handleValueChange(slot.id, e.target.value);
                                }}
                              />
                            )}
                            rules={{ required: false }}
                          />
                          {errors[`slot-${slot.id}`] && <span className="text-danger">This field is required</span>}
                          <div className="d-flex gap-3">
                            <Button color="danger" onClick={() => removeSlot(slot.id)} className="mt-3">
                              Remove
                            </Button>
                            {slots.length < MAX_SLOTS && (
                              <Button color="primary" onClick={addSlot} className="mt-3">
                                Add Slot
                              </Button>
                            )}
                          </div>
                        </FormGroup>)) 
                        }
                 
                    </Fragment>
                      )}
                  {/* )} */}

                  <CardFooter className="p-0 d-flex gap-2 justify-content-end">
                    <Button className="success " color="danger" onClick={()=> navigate(`${process.env.PUBLIC_URL}/settings/slotdetails/:layout`)}>
                      {"Cancel"}
                    </Button>
                    <Button className="success" color="success" type="submit">
                      {"Submit"}
                    </Button>
                  </CardFooter>
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
      </Form>
    </Fragment>
  )
};

export default TimeSlotForm;
